export type WeightSeriesKeyRange = {
  readonly from: string;
  readonly to: string;
};

export const keys = {
  all: ['weight-tracking'] as const,
  latest: () => [...keys.all, 'latest'] as const,
  list: () => [...keys.all, 'list'] as const,
  series: (range: WeightSeriesKeyRange) =>
    [...keys.all, 'series', range.from, range.to] as const,
};
